import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
  Validator,
} from "common";
import I18n from "i18n-js";
import { getSubmitService, SubmitFormItem, SubmitOptions } from "./submitApi";

export interface UseSubmitFormProps extends GridModalFormProps {}

export default function useSubmitForm({ id, afterSave }: UseSubmitFormProps) {
  const service = getSubmitService();

  const form = useForm<SubmitFormItem, SubmitOptions>({
    id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "Submit",
    rules: {
      first_name: Validator.rule.any().required(),
      last_name: Validator.rule.any().required(),
      email: Validator.rule.any().required(),
      group: Validator.rule.any().required(),
      status: Validator.rule.any().required(),
    },
    afterSave,
    afterLoad: _newItem => {},
    onValidationFailed: () => {
      globalMessageHandler.error(I18n.t("App.formHasErrors"));
    },
    ...service,
  });

  return form;
}
